var details = {
    type : 'stateless',
    name : 'stateless'
};

module.exports = function MStateless() {
    this.getDetails = function() {
        return details;
    };
    
    this.parse = function(buffer) {
        return buffer;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/metadata/stateless.js
// module id = 460
// module chunks = 1